// extracted by mini-css-extract-plugin
export default {"projectPage":"ProjectPage_projectPage__edNTS","projectGrid":"ProjectPage_projectGrid__3OTeU","project":"ProjectPage_project__PESoX"};